import React, { useState } from 'react';
import Select from 'react-select';
import { countryList } from './CountryList';
import CityAutocomplete from './CityAutoComplete';
import './CountryCityRows.css';

const CountryCityRows = ({ countryCityRows, setCountryCityRows }) => {
  // Add a new row
  const addRow = () => {
    setCountryCityRows([...countryCityRows, { country: null, cities: [] }]);
  };

  // Remove a row
  const removeRow = (idx) => {
    setCountryCityRows(countryCityRows.filter((_, i) => i !== idx));
  };

  // Update a country in a row
  const handleCountryChange = (country, idx) => {
    const updated = [...countryCityRows];
    updated[idx] = { country, cities: [] }; // Reset cities when country changes
    setCountryCityRows(updated);
  };

  // Update cities in a row
  const handleCitiesChange = (cities, idx) => {
    const updated = [...countryCityRows];
    // Add cityAndCountry field to each city
    const countryName = updated[idx].country?.label || '';
    updated[idx].cities = cities.map(city => ({
      ...city,
      cityAndCountry: `${city?.name || ''}, ${countryName}`
    }));
    // Also update cityStr as a comma-separated string of city names
    updated[idx].cityStr = updated[idx].cities.map(city => city?.name || '').filter(Boolean).join(', ');
    setCountryCityRows(updated);
  };

  return (
    <div>
      {countryCityRows.map((row, idx) => (
        <div key={idx} className="country-city-row">
          <div className="country-select">
            <Select
              options={countryList}
              value={row.country}
              onChange={country => handleCountryChange(country, idx)}
              placeholder="Select country"
              classNamePrefix="react-select"
              isClearable
              isSearchable
             
            />
          </div>
          <div className="cities-and-add">
            <div className="city-autocomplete">
              <CityAutocomplete
                selectedCountries={row.country ? [row.country] : []}
                selectedCities={row.cities}
                setSelectedCities={cities => handleCitiesChange(cities, idx)}
              />
            </div>
            <button
              type="button"
              className="circle-btn add-btn"
              onClick={addRow}
              aria-label="Add row"
            >＋</button>
          </div>
          {countryCityRows.length > 1 && (
            <button
              type="button"
              className="circle-btn remove-btn"
              onClick={() => removeRow(idx)}
              aria-label="Remove row"
            >×</button>
          )}
        </div>
      ))}
    </div>
  );
};

export default CountryCityRows;